module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/124ea6269c267395123ec9f1d2c5c587.png";